import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import ConceptSection from '../components/ConceptSection';
import NRFSection from '../components/NRFSection';
import FormatsSection from '../components/FormatsSection';
import EventsSection from '../components/EventsSection';
import TeamSection from '../components/TeamSection';
import SponsorsSection from '../components/SponsorsSection';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>The Recap - Décryptage des événements e-commerce et retail du marché</title>
        <meta name="description" content="The Recap capture l'essentiel des grands événements retail et e-commerce et le transforme en analyses claires et actionnables pour les entreprises." />
        <meta property="og:title" content="The Recap - Décryptage des événements e-commerce et retail du marché" />
        <meta property="og:description" content="The Recap capture l'essentiel des grands événements retail et e-commerce et le transforme en analyses claires et actionnables pour les entreprises." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/images/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="The Recap - Décryptage des événements e-commerce et retail du marché" />
        <meta name="twitter:description" content="The Recap capture l'essentiel des grands événements retail et e-commerce et le transforme en analyses claires et actionnables pour les entreprises." />
      </Helmet>
      <HeroSection />
      <ConceptSection />
      <NRFSection />
      <FormatsSection />
      <EventsSection />
      <TeamSection />
      <SponsorsSection />
    </>
  );
};

export default HomePage;
